import React, { useEffect, useState } from "react"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/cart/localization"
import ProductCardView from "@/components/productCard/v1/ProductCard.view"
import CONSTANTS from "@/constants/index"
import styles from "@/components/PairsWellWith/index.module.scss"
import { getMoreInCollectionSlider } from "@/components/productCard/v1/analytics"

const PairsWellWithView = ({
  pairsProductProps,
  currencySign,
  presetConfigs,
  swatchUrl,
  source,
  title,
}) => {
  const { t } = useTranslation("common")
  const [staticText] = useState(getTranslations(t))
  const { COMPONENT } = CONSTANTS

  useEffect(() => {
    const scrollDiv = document.querySelector(".pairs-well-with__carousel")
    if (scrollDiv) {
      scrollDiv.addEventListener(
        "mousedown",
        e => {
          const horizontalCoordinate = e.offsetX
          const verticalCoordinate = e.offsetY
          e.stopPropagation()

          if (
            !e.scrollClicked &&
            horizontalCoordinate >= 30 &&
            verticalCoordinate >= 563
          ) {
            getMoreInCollectionSlider(title ?? "")
            e.scrollClicked = false
          }
        },
        true
      )
    }

    return () => {
      if (scrollDiv) {
        scrollDiv.removeEventListener("mousedown")
      }
    }
  }, [])
  return (
    <div className={styles.pairsWellWithModalWrapper}>
      <div
        className={`pairs-well-with pairs-well-with--recommended-product ${
          source === "recently-viewed" ? "--recently-viewed" : ""
        }`}
      >
        <div className="kf-react-plp-container">
          {/* the recently viewwed title */}
          <div className="row ml-0 mr-0">
            {pairsProductProps?.length > 0 && (
              <div className="col-12 pairs-well-with__title">
                <h4 aria-level="3">{title}</h4>
              </div>
            )}
          </div>
          {/* the products with product tiles */}
          <div className="row ml-0 mr-0">
            <div className="col-12 pairs-well-with__carousel">
              {pairsProductProps?.length > 0 &&
                pairsProductProps.map((product, i) => (
                  <ProductCardView
                    i18n={staticText}
                    {...product}
                    product={product}
                    key={i}
                    currencySign={currencySign}
                    presetConfigs={presetConfigs}
                    swatchUrl={swatchUrl}
                    parent={COMPONENT.PAIRS_WELL_WITH}
                    title={title}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PairsWellWithView
